export const normalizeDate = (date: string | Date) => {
  const normalized = new Date(date);
  normalized.setHours(0, 0, 0, 0); // Set to midnight
  return normalized;
};

export const toExponentialUppercase = (value, fractionDigits) => {
  return value.toExponential(fractionDigits).toUpperCase();
};

export const toExponentialUppercaseWhitZero = (value, fractionDigits) => {
  const exponentialValue = Number(value)
    .toExponential(fractionDigits)
    .toUpperCase();
  return exponentialValue.replace("E", "0E");
};

export const mapArrayToNumber = (array) => {
  return array
    .filter((value) => value !== "" && value !== null && value !== undefined)
    .map((value) => parseFloat(String(value).replace(",", ".")));
};

export const convertToNumber = (value) => {
  return parseFloat(String(value).replace(",", "."));
};
